import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import '../../../../../styles/balanco.scss'

const Cargo = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchCargos()
    }


    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <tr>

                <td>
                    {props.cargo.cargo}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="mx-2 text-warning cursor-pointer"
                        title="Editar"
                        onClick={() => editar(props.cargo._id)}
                    />
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                    <FontAwesomeIcon
                        icon={faTrash}
                        className="mx-2 text-danger cursor-pointer"
                        title="Excluir"
                        onClick={() => deletar(props.cargo._id)}
                    />
                </td>
            </tr>
        </Fragment >)
}

export default Cargo;